import { getCurrentDate } from '../utils/dateFormatter';

const initialState = {
  isFetching: false,
  selectedDate: '',
  showWinners: false,
  nextUpdateTime: null,
  winnersList: [],
  data: []
};

export default function events(state = initialState, action) {
  switch (action.type) {
    case 'FETCHING_EVENT_DATA':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCHING_EVENT_DATA_FAILURE':
      return {
        ...state,
        isFetching: false
      };
    case 'FETCHING_EVENT_DATA_SUCCESS':
      return {
        ...state,
        isFetching: false,
        selectedDate: action.selectedDate,
        showWinners: !!(action.winnersList && action.data.userDetails),
        nextUpdateTime: action.data.refreshedTime || null,
        data: action.data && action.data.userDetails ? action.data.userDetails : action.data
      };
    case 'UPDATE_WINNERS_LIST':
      return {
        ...state,
        winnersList:
          action.winnersList && action.data && action.data.userDetails
            ? action.data.userDetails
            : []
      };
    case 'SHOW_WINNERS_LIST':
      return {
        ...state,
        showWinners: action.data
      };
    default:
      return state;
  }
}
